import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { mergeClassNames } from '../utils/mergeClassNames.es.js';
import { RadioGroup as RadioGroup$1 } from 'react-aria-components';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';

const radioGroup = "_radio-group_k56ft_1";
const styles = {
	radioGroup: radioGroup
};

const RadioGroup = (_a) => {
  var { children, className, isRequired, label, description, errorMessage } = _a, props = __rest(_a, ["children", "className", "isRequired", "label", "description", "errorMessage"]);
  return jsx(RadioGroup$1, Object.assign({ className: (renderProps) => mergeClassNames([styles.radioGroup, className], renderProps), "data-zds": true, isRequired }, props, { children: (renderProps) => jsxs(Fragment, { children: [label && jsx(Label, { isRequired, children: label }), typeof children === "function" ? children(renderProps) : children, description && jsx(Description, { children: description }), jsx(ErrorMessage, { children: errorMessage })] }) }));
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.es.js.map
